import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    public route: Router
  ) { }

  ngOnInit(): void {
  }

  logout() {
    localStorage.removeItem('CurrentUser');
    this.route.navigateByUrl('/auth/login-in');

  }

}
